import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

import { StyledListItemContainer } from "../styles";

export const StyledLoadersWrapper = styled.div`
    padding-top: 24px;
`;

export const StyledListSectionBody = styled(FlexRow)`
    flex-wrap: wrap;
    column-gap: 20px;
    margin-top: 20px;
    row-gap: 16px;

    & ${StyledListItemContainer} {
        width: calc(50% - 20px / 2);
    }
`;

export const StyledListSection = styled.div`
    &:not(:last-child) {
        margin-bottom: 64px;
    }
`;
